/*=========================================================================================
  File Name: moduleSuspectState.js
  Description: Suspect Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  suspects: []
}
  